import Vue from "vue";

export default {
  enumStatus: {
    ATIVO: "ATIVO",
    APROVADO: "APROVADO",
    INATIVO: "INATIVO",
    PENDENTE: "PENDENTE",
    RECUSADO: "RECUSADO",
  },

  async getAcessoPessoa(id) {
    return Vue.prototype.$http.get(`/acessos/pessoas/${id}`);
  },

  async getAcessoVeiculo(id) {
    return Vue.prototype.$http.get(`/acessos/veiculos/${id}`);
  },

  getAcessos(page = 0, filtro) {
    let requisicao = `/acessos/pessoas?page=${page}`;
    if (filtro) {
      requisicao += `&${new URLSearchParams(filtro).toString()}`;
    }
    return Vue.prototype.$http.get(requisicao);
  },

  getAcessosVeiculos(page = 0, filtro) {
    let requisicao = `/acessos/veiculos?page=${page}`;
    if (filtro) {
      requisicao += `&${new URLSearchParams(filtro).toString()}`;
    }
    return Vue.prototype.$http.get(requisicao);
  },

  getAcessosVeiculosByPlaca(placa) {
    return Vue.prototype.$http.get(`/acessos/veiculos?page=0&${placa}`);
  },

  createAcessoPessoa(form) {
    return Vue.prototype.$http.post("/acessos/pessoas", form);
  },

  createAcessoVeiculo(form) {
    return Vue.prototype.$http.post("/acessos/veiculos", form);
  },

  updateAcessoPessoa(id, form) {
    return Vue.prototype.$http.put(`/acessos/pessoas/${id}`, form);
  },

  updateAcessoVeiculo(id, form) {
    return Vue.prototype.$http.put(`/acessos/veiculos/${id}`, form);
  },

  setStatusAcessoPessoaInativo(id) {
    return Vue.prototype.$http.put(`/acessos/pessoas/${id}/inativar`);
  },

  setStatusAcessoPessoa(id, status) {
   if (Object.values(this.enumStatus).includes(status)) {
      return Vue.prototype.$http.put(
        `/acessos/pessoas/${id}/status`,
        { status },
        { headers: { "Content-Type": "application/json" } }
      );
    } else {
      console.error("Status inválido:", status);
      return Promise.reject(new Error("Status inválido"));
    }
  },

  setRecusarAcessoPessoa(id, motivo) {
    const payload = {
      status: this.enumStatus.RECUSADO,
      motivoRecusa: motivo,
    };
    return Vue.prototype.$http.put(`/acessos/pessoas/${id}/status`, payload, {
      headers: { "Content-Type": "application/json" },
    });
  },

  setRecusarAcessoVeiculo(id, motivo) {
    const payload = {
      status: this.enumStatus.RECUSADO,
      motivoRecusa: motivo,
    };
    return Vue.prototype.$http.put(`/acessos/veiculos/${id}/status`, payload, {
      headers: { "Content-Type": "application/json" },
    });
  },

  setStatusAcessoVeiculoInativo(id) {
    try {
      return Vue.prototype.$http.put(`/acessos/veiculos/${id}/inativar`);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  setStatusAcessoVeiculo(id, status) {
    if (status == "INATIVO") {
      this.setStatusAcessoVeiculoInativo(id);
      return Promise.resolve();
    } 
    if (Object.values(this.enumStatus).includes(status)) {
      return Vue.prototype.$http.put(
        `/acessos/veiculos/${id}/status`,
        { status },
        { headers: { "Content-Type": "application/json" } }
      );
    } else {
      console.error("Status inválido:", status);
      return Promise.reject(new Error("Status inválido"));
    }
  },

  deleteAcessoPessoa(id) {
    this.setStatusAcessoPessoa(id, "INATIVO");
  },

  deleteAcessoVeiculo(id) {
    this.setStatusAcessoVeiculo(id, "INATIVO");
  },
};
